import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducer from './reducers/reducer';
import developmentImage from './assets/images/ducklings.jpg';
const uploadedFileUrl = (process.env.NODE_ENV === 'production') ? null : developmentImage

const store = createStore(reducer);

store.dispatch ({
	type: 'SET_STATE',
	state: {
		frameProducts: [],
		productsCount: 0,
	    frameCategories: [],
	    displayCategory: 16,
	    catProCount: 0,
	    frameLoading: true,
	    selectedFrame: [],
        frameImage: null,
	    frameTotal: 0,
	    frameSizeH: 0,
	    frameSizeW: 0,
	    frameFullDimension: 40,
	    canvasImage: null,
	    canvasThumbImage: null,
	    frameImageHeight: 20,
	    frameImageWidth: 20,
	    uploadedImageHeight: 20,
	    uploadedImageWidth: 20,
	    imageSizeError: false,
	    aspectRatio: 1,
	    framedCalc: {},

	    glasses: [],
	    selectedGlass: null,
	    glassTotal: 0,
    	selectedGlassName: null,

	    backings: [],
	    selectedBacking: null,
	    backingTotal: 0,
	    selectedBackingName: null,

	    printing: [],
	    selectedPrint: null,
	    printTotal: 0,
    	selectedPrintName: null,

	    wallcolor: '#fff',

	    roomImages: [],
		selectedRoomImage: [],

		libraryImageUploading: false,

        mats: [],
        matView: 0,
        selectedMatSize: 0,
	    selectedTopMat: [],
	    selectedMiddleMat: [],
	    selectedBottomMat: [],
	    selectedTopMatValueInCM: 0.5,
		selectedMiddleMatValueInCM: 0.5,
		selectedBottomMatValueInCM: 0.5,
	    topMatTotal: 0,
    	middleMatTotal: 0,
    	bottomMatTotal: 0,
    	matsLoaded: false,

    	qty: 1,
    	cartQty: 0,
    	customizeQTY: 0,
    	cart1ItemTotal: 0,
    	uploadedFile: uploadedFileUrl,
		selectedTab: 'frames',

		viewportWidth: 0,
		viewportHeight: 0,
		rightFrameHeight: 0,

		showMeHow: false
	}
})

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>, document.getElementById('root')
);
//registerServiceWorker();